import React, { useState, useEffect, useMemo } from 'react'
import { Field, reduxForm, change as changeFieldValue } from 'redux-form'
import { translate } from 'react-polyglot'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import useAxios from 'axios-hooks'

import { Form, Button } from 'components'

import { Text, Url } from 'components/FormField'

import { required } from 'utils/validation'
import { createSlug } from 'utils/common'

const CreateTeamForm = props => {
	const {
		handleSubmit,
		handleReset,
		pristine,
		reset,
		submitting,
		error,
		t,
	} = props

	const [teamUrl, setTeamUrl] = useState('')
	const [teamUrlTouched, setTeamUrlTouched] = useState(false)

	const [{ error: postError }, executePost] = useAxios(
		{
			url: 'auth/check-slug',
			method: 'POST',
		},
		{ manual: true }
	)

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (teamUrl.length) {
				executePost({
					data: {
						slug: teamUrl,
					},
				})
			}
		}, 350)

		return () => clearTimeout(timeout)
	}, [teamUrl])

	const uniqueSlug = useMemo(
		() => () => (postError ? postError.response.data.message : undefined),
		[postError]
	)

	return (
		<Form
			onSubmit={handleSubmit}
			actions={
				<>
					<Button
						type="submit"
						text={t('settings.create_team')}
						layout="primary"
						disabled={submitting}
					/>
					<Button
						type="reset"
						text={t('cancel')}
						onClick={e => {
							handleReset()
							reset()
						}}
					/>
				</>
			}
			error={error}
		>
			<Field
				name="team"
				label={t('forms.team_name')}
				component={Text}
				validate={[required]}
				onChange={e => {
					if (!teamUrlTouched) {
						props.changeFieldValue(
							'newTeam',
							'teamUrl',
							createSlug(e.target.value)
						)

						setTeamUrl(createSlug(e.target.value))
					}
				}}
				disabled={submitting}
			/>{' '}
			<Field
				name="teamUrl"
				label={t('forms.team_url')}
				component={Url}
				validate={[required, uniqueSlug]}
				onChange={e => {
					props.changeFieldValue(
						'newTeam',
						'teamUrl',
						createSlug(e.target.value)
					)

					setTeamUrl(createSlug(e.target.value))

					if (createSlug(e.target.value).length > 0) {
						setTeamUrlTouched(true)
					} else {
						setTeamUrlTouched(false)
					}
				}}
				disabled={submitting}
			/>
		</Form>
	)
}

const mapDispatchToProps = dispatch =>
	bindActionCreators({ changeFieldValue }, dispatch)

export default connect(
	null,
	mapDispatchToProps
)(
	reduxForm(
		{
			form: 'newTeam',
		},
		mapDispatchToProps
	)(translate()(CreateTeamForm))
)
